import { AgeVerificationMethodType } from "@next-platform/packages-ts-types";
import type { TFunction } from "i18next";

// More on that here https://docs.verifymyage.com/docs/adult/authorisation/index.html#method-parameter
// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAgeVerificationMethodOptions = (t: TFunction) => ({
  [AgeVerificationMethodType.ID_SCAN_FACE_MATCH]: {
    label: t("ageVerification:method.idScanFaceMatch.label"),
    description: t("ageVerification:method.idScanFaceMatch.description"),
  },
  [AgeVerificationMethodType.DOUBLE_BLIND]: {
    label: t("ageVerification:method.doubleBlind.label"),
    description: t("ageVerification:method.doubleBlind.description"),
  },
  [AgeVerificationMethodType.FACIAL_AGE_ESTIMATION]: {
    label: t("ageVerification:method.facialAgeEstimation.label"),
    description: t("ageVerification:method.facialAgeEstimation.description"),
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention -- keep the key as is to match the method type from the backend
  FacialWithIDFallback: {
    label: t("ageVerification:method.facialAgeEstimation.label.fallback"),
    description: t("ageVerification:method.default.description.fallback"),
  },
  [AgeVerificationMethodType.EMAIL]: {
    label: t("ageVerification:method.email.label"),
    description: t("ageVerification:method.email.description"),
  },
  [AgeVerificationMethodType.ID_SCAN]: {
    label: t("ageVerification:method.idScan.label"),
    description: t("ageVerification:method.idScan.description"),
  },
  [AgeVerificationMethodType.MOBILE]: {
    label: t("ageVerification:method.mobile.label"),
    description: t("ageVerification:method.mobile.description"),
  },
  [AgeVerificationMethodType.CREDIT_CARD]: {
    label: t("ageVerification:method.creditCard.label"),
    description: t("ageVerification:method.creditCard.description"),
  },
});

export default getAgeVerificationMethodOptions;
